// constants
import { DEFAULT_SETTING } from './constants';
import { BREAKPOINTS } from 'shared/styles/base';

export const getSettings = () => {
  const width = window.innerWidth;

  if (width > BREAKPOINTS.DESKTOP) {
    return DEFAULT_SETTING;
  }

  if (width > BREAKPOINTS.TABLET_BIG) {
    const imageWidth = (width - 120) / 3;
    const imageHeight = imageWidth / 0.75;
    return {
      ...DEFAULT_SETTING,
      REELCOUNT: 3,
      IMAGE_HEIGHT: imageHeight,
      IMAGE_WIDTH: imageWidth,
      slotStyle: { margin: '0 30px 0 0', padding: '0' },
      carouselStyle: { position: 'relative', padding: '0' },
    };
  }

  if (width <= BREAKPOINTS.TABLET_BIG) {
    const imageWidth = (width - 50) / 2;
    const imageHeight = imageWidth / 0.75;
    return {
      ...DEFAULT_SETTING,
      REELCOUNT: 3,
      IMAGE_HEIGHT: imageHeight,
      IMAGE_WIDTH: imageWidth,
      slotStyle: { margin: '0 10px 0 0', padding: '0' },
      carouselStyle: { position: 'relative', padding: '0' },
    };
  }

  return DEFAULT_SETTING;
};
